import { LocalOverrideAdapter } from '@statsig/js-local-overrides';
import { getEnv } from 'util/getEnv';

export const getOverrideAdapter = () => {
  const overrideAdapter = new LocalOverrideAdapter(
    getEnv('REACT_APP_STATSIG_KEY'),
  );
  if (window.statsigOverrides) {
    Object.entries(window.statsigOverrides.gates).forEach(
      ([gateName, value]) => {
        overrideAdapter.overrideGate(gateName, value);
      },
    );
  }
  return overrideAdapter;
};
